import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {ChartsLabelMark, legendClasses, LineChart} from '@mui/x-charts';
import {XYVO} from "@/service/analyze";
import {lineElementClasses} from "@mui/x-charts/LineChart";
import {transformMoney} from "@/helper/method";

export interface YearPaybackTrendProps {
    lastYearPaybacks: XYVO[]
    thisYearPaybacks: XYVO[]
    loading: boolean
}

export default function YearPaybackTrend({lastYearPaybacks, thisYearPaybacks, loading}: YearPaybackTrendProps) {
    const thisYear = new Date().getFullYear();
    const lastYear = thisYear - 1
    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Stack alignContent={'start'} alignItems={'start'} direction={'row'} justifyContent={'space-between'}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        年度回款对比
                    </Typography>
                    <Stack alignItems={'start'} direction={'row'} spacing={2}>
                        <Stack alignItems={'center'} spacing={1} direction={'row'}>
                            <ChartsLabelMark type={'square'} color={'#ff0000'}/>
                            <Typography sx={{display: 'inline-block', alignItems: 'start'}}>{`${2024}年`}</Typography>
                        </Stack>
                        <Stack alignItems={'center'} spacing={1} direction={'row'}>
                            <ChartsLabelMark type={'square'} color={'yellow'}/>
                            <Typography sx={{display: 'inline-block', alignItems: 'start'}}>{`${2025}年`}</Typography>
                        </Stack>
                    </Stack>
                </Stack>
                <LineChart
                    height={180}
                    loading={loading}
                    localeText={{loading: "加载中"}}
                    series={[
                        {data: lastYearPaybacks?.map(item => item.y), label: `${lastYear}年`, valueFormatter: value => transformMoney(value), showMark: false,},
                        {
                            data: thisYearPaybacks?.map(item => item.y), valueFormatter: value => transformMoney(value),
                            label: `${thisYear}年`, showMark: false
                        },
                    ]}
                    hideLegend={true}
                    sx={{
                        [`.${lineElementClasses.root}`]: {
                            strokeWidth: 4,
                        },
                    }}
                    slotProps={{
                        legend: {
                            direction: 'horizontal',
                            position: {
                                vertical: 'top',
                                horizontal: 'end',
                            },
                            sx: {
                                gap: '16px',
                                // CSS-in-JS
                                [`.${legendClasses.mark}`]: {
                                    height: 15,
                                    width: 15,
                                },
                                // CSS class
                                ['.MuiChartsLegend-series']: {
                                    gap: '8px',
                                },
                            },
                        },
                    }}
                    xAxis={[{scaleType: 'point', data: lastYearPaybacks?.map(item => item.x), disableTicks: true,}]}
                    yAxis={[{width: 40, disableTicks: true, disableLine: true, valueFormatter: (value: number) => transformMoney(value)}]}
                    margin={{left: 0, right: 0, top: 10, bottom: 0}}
                />
            </CardContent>
        </Card>
    );
}
